import { render, staticRenderFns } from "./FuncionalidadeHeader.vue?vue&type=template&id=0096ecfe&scoped=true"
import script from "./FuncionalidadeHeader.vue?vue&type=script&lang=js"
export * from "./FuncionalidadeHeader.vue?vue&type=script&lang=js"
import style0 from "./FuncionalidadeHeader.vue?vue&type=style&index=0&id=0096ecfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0096ecfe",
  null
  
)

export default component.exports